var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"v-form__list v-form__list--replicator form__list--full-width"},[_vm._t("default",null,{"count":_vm.count,"data":_vm.localData})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }